module.exports = "/images/icon_exit_black.svg?85c16742c2ad4a68fb15e0daa7b9b086";